import CloseLine from '@assets/svgs/CloseLine.svg';

type CloseModalButtonPropsType = {
  dark?: boolean;
  onClose: Function;
  onClickClose?: Function;
};

const CloseModalButton = ({
  dark,
  onClose,
  onClickClose,
}: CloseModalButtonPropsType): React.ReactElement => {
  const closeButtonIconColor = () => {
    return dark ? 'mobile:fill-white' : 'mobile:content_primary';
  };

  const handleClickClose = () => {
    onClickClose && onClickClose();
    onClose();
  };

  return (
    <button
      type="button"
      onClick={handleClickClose}
      className="flex items-center justify-center w-[32px] h-[32px] rounded-[50%] surface_tertiary"
    >
      <CloseLine
        className={`w-[24px] h-[24px] mobile:w-[20px] mobile:h-[20px] ${closeButtonIconColor()}`}
      />
    </button>
  );
};

export default CloseModalButton;
